import React from 'react';
import { SectionInstance } from '../types';

interface Props {
  section: SectionInstance;
}

const StatsBar: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  const stats = (c.stats || []) as Array<{ number?: string; value?: string; label: string; suffix?: string }>;
  const bg = c.background || 'primary';

  const bgStyle: React.CSSProperties = { padding: '40px 24px' };
  const textColor = bg === 'primary' ? '#fff' : 'var(--brand-primary, #2563eb)';
  const labelColor = bg === 'primary' ? 'rgba(255,255,255,0.8)' : '#64748b';

  if (bg === 'primary') bgStyle.background = 'var(--brand-primary, #1a365d)';
  else if (bg === 'alt') bgStyle.background = 'var(--brand-bg-alt, #f8fafc)';
  else bgStyle.background = '#fff';

  return (
    <section className="sb-render sb-render-stats-bar" style={bgStyle}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'center', gap: 48, flexWrap: 'wrap' }}>
        {stats.map((s, i) => (
          <div key={i} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 700, letterSpacing: '-0.025em', color: textColor }}>
              {s.number || s.value || '—'}{s.suffix || ''}
            </div>
            <div style={{ fontSize: '0.875rem', color: labelColor }}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
